import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import './Articles.css'
import MoreImagesCard from '../../components/MoreImagesCard';
import { useParams } from 'react-router-dom';
import ChevronRight from '../../icons/ChevronRight';
import { useTranslation } from 'react-i18next';
import useLanguagePrefix from '../../LanguagePrefix';
import CheckCircle from '../../icons/CheckCircle';


function NewsArticle() {
    const { t } = useTranslation();
    const langPrefix = useLanguagePrefix();

    return (
        <div>
            <Helmet>
                <title>Prostay - All In One Property Management System</title>
                <meta name="description" content="Cutting-edge Property Management System designed to revolutionize the way hotels, and resorts from boutique to large-scale, operate and serve their guests." />
                <link rel="canonical" href={"https://www.prostay.com" + langPrefix + "/news/prostay-launches-a-new-standard-in-hotel-management-technology/"} />

                <link rel="alternate" href="https://www.prostay.com/en/news/prostay-launches-a-new-standard-in-hotel-management-technology/" />
                <link rel="alternate" href="https://www.prostay.com/es/news/prostay-launches-a-new-standard-in-hotel-management-technology/" />

                <meta property="og:title" content="Prostay - All In One Property Management System" />
                <meta property="og:description" content="Cutting-edge Property Management System designed to revolutionize the way hotels, and resorts from boutique to large-scale, operate and serve their guests." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={"https://www.prostay.com" + langPrefix + "/news/prostay-launches-a-new-standard-in-hotel-management-technology/"} />
                <meta property="og:image" content='https://prostay.com/images/ogImage.png' />

                <meta property="og:site_name" content="Prostay" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Prostay - All In One Property Management System" />
                <meta name="twitter:description" content="Cutting-edge Property Management System designed to revolutionize the way hotels, and resorts from boutique to large-scale, operate and serve their guests." />
                <meta name="twitter:image" content='https://prostay.com/images/ogImage.png' />
                <meta name="twitter:site" content="@prostaypms" />
                <meta name="twitter:creator" content="@prostaypms" />


            </Helmet>

            <div className='article-page'>
                <div className='background-image'>
                    <div className='background-image-start'>
                        <div className='d-flex align-items-center gap-2 gap-md-3 breadcrumbs'>
                            <a href={`${langPrefix}/`} style={{ textDecoration: 'none' }}><small style={{ cursor: 'pointer' }}>{t('Home')}</small></a>
                            <ChevronRight />
                            <a href={`${langPrefix}/news/`} style={{ textDecoration: 'none' }}><small style={{ cursor: 'pointer' }}>{t('News & Press')}</small></a>
                            <ChevronRight />
                            <small style={{ cursor: 'pointer', color: "#1643E0" }}>{t('Prostay Launches: A New Standard in Hotel Management Technology')}</small>
                        </div>
                        <div className='mt-4'>
                            <h1>
                                {t(`Prostay Launches: A New Standard in Hotel Management Technology`)}
                            </h1>
                        </div>
                    </div>
                </div>
                <div className='d-flex justify-content-center'>
                    <div className='page-content mt-2 mt-md-4'>
                        <p className='body-xlarge'>{t('After a full year of focused development and industry-driven design, Prostay has officially launched today April 8th 2025 —ushering in a new era of modern hotel technology. Purpose-built for hotels, resorts, and vacation rentals, Prostay introduces a fully integrated platform that unites operations, distribution, and guest engagement into a single, powerful solution.')}</p>
                        <hr className=' my-4' />
                        <div className='d-flex flex-column mt-4'>
                            <small className='body-small' >{t('The journey began on April 2, 2024, when the Prostay team set out to solve the longstanding inefficiencies of disconnected, outdated hotel systems. Over the following twelve months, product development accelerated with input from hospitality professionals, leading to a modular, cloud-based (and on-premise ready) platform designed to scale with properties of all sizes.')}</small>
                            <small className='body-small mt-3'>{t('With today’s public launch, Prostay introduces its core suite of modules:')}</small>
                            <div className='d-flex flex-column gap-3'>
                                <div className='d-flex gap-2 mt-3'>
                                    <CheckCircle className='check-dimension' />
                                    <label>
                                        {t('A sleek and powerful Property Management System (PMS)')}
                                    </label>
                                </div>
                                <div className='d-flex gap-2'>
                                    <CheckCircle className='check-dimension' />
                                    <label>
                                        {t('A real-time, conversion-optimized Booking Engine')}
                                    </label>
                                </div>
                                <div className='d-flex gap-2'>
                                    <CheckCircle className='check-dimension' />
                                    <label>
                                        {t('An integrated Channel Manager for OTA distribution')}
                                    </label>
                                </div>
                                <div className='d-flex gap-2'>
                                    <CheckCircle className='check-dimension' />
                                    <label>
                                        {t('The native guest messaging platform, Prostay Nexus')}
                                    </label>
                                </div>
                                <div className='d-flex gap-2'>
                                    <CheckCircle className='check-dimension' />
                                    <label>
                                        {t('And the official integration of its proprietary Point of Sale system, Tableview')}
                                    </label>
                                </div>
                            </div>
                            <div className='d-flex flex-column gap-3 mt-3'>
                                <small className='body-small'>
                                    {t('Together, these tools form a unified hospitality operating system, built with flexibility, usability, and performance at its core. Operators can manage room operations, guest communication, restaurant and bar orders, online distribution, and front office tasks—all from a single interface, with modules that work natively together.')}
                                </small>
                                <small className='body-small'>
                                    {t('Tableview, Prostay’s integrated Point of Sale system and sister company, offers full support for in-room dining, restaurant orders, bar service, poolside tablets, and retail outlets. Charges can be posted directly to guest rooms in real time, with full compatibility across Prostay’s folio management and reporting systems. The POS is available on Windows, iPads, and Android tablets, with offline mode and live sync built-in.')}
                                </small>
                                <small className='body-small'>
                                    {t('Designed to be both cloud-native and on-premise compatible, Prostay also features robust offline capabilities—ensuring that even properties with unreliable internet remain fully operational. Its native apps for Windows, macOS, Android, and iPads provide a fluid experience across departments and devices, from front office to housekeeping to F&B.')}
                                </small>
                                <small className='body-small'>
                                    {t('Early adopters have already begun implementing Prostay across Southeast Asia and Europe, reporting faster staff onboarding, smoother guest communication, and increased direct bookings. With flexible pricing, multilingual support, and a powerful API, Prostay is positioned to become a go-to platform for independent properties and multi-property groups alike.')}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}



export default NewsArticle;
